<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title header-title"
      >Add ingredients to make 1kg/litre of product</span
    >
    <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="productIngredientForm" [ngClass]="{ 'disabled-popup': !showEdit }">
      <div formGroupName="ingredientDetailFormGroup">
        <div class="setTitleAndIcon">
          <div>
            <span class="setFont">Ingredients</span>
          </div>
          <div>
            <div class="addtooltips">
              <ng-template #tipContent>
                <div class="row">
                  <span class="selectedMaterialDiv d-flex align-items-start justify-content-start"
                    >{{ materialname }}
                  </span>
                  <div
                    class="col-md-12 d-flex align-items-start justify-content-start pt-2"
                    *ngFor="let item of materialInfoData | keyvalue"
                  >
                    <ng-container *ngIf="item.key !== 'name'">
                      <span class="col-4 d-flex align-items-start justify-content-start alignData"
                        >{{ toTitleCase(item.key) }}:
                      </span>
                      <span class="col-8 d-flex align-items-start justify-content-start alignData"
                        >{{ item.value }}
                      </span>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
              <div
                placement="auto"
                tooltipClass="material-data"
                [ngbTooltip]="tipContent"
                data-bs-placement="auto"
              >
                <a> <i class="bi bi-question-circle iconQuestion"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group required">
              <label
                *ngIf="
                  productIngredientForm.get('ingredientDetailFormGroup')?.get('ingredientName')
                    ?.value
                "
                class="sub-header-drpdown pb-2"
                >Ingredient</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #ingredient
                [items]="ingredientItem"
                [searchable]="false"
                bindLabel="name"
                formControlName="ingredientName"
                [searchFn]="commonInputSearchForName"
                placeholder="Select ingredient *"
                groupBy="childItems"
                (change)="getUnitValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="ingredient.filter($any($event.target).value)"
                      class="form-control search-input search"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                    {{ item?.name }}
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                    {{ item?.name }}
                  </div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  submitForIngredient &&
                  productIngredientForm.get('ingredientDetailFormGroup')?.get('ingredientName')
                    ?.errors
                "
              >
                <div
                  *ngIf="
                    productIngredientForm.get('ingredientDetailFormGroup')?.get('ingredientName')
                      ?.invalid
                  "
                  class="input-error"
                >
                  Ingredient is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                label="Weight"
                name="ingredientWeigth"
                placeholder="Weight"
                formControlName="ingredientWeigth"
                [control]="ingredientDetailFormGroup?.get('ingredientWeigth')"
                [submitted]="submitForIngredient"
                [maxLength]="100"
                inputType="number"
                [required]="true"
                [preventNegative]="true"
              ></piqet-angular-common-input>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" aria-required="true">
              <label class="sub-header-drpdown">Unit</label>
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                [virtualScroll]="true"
                #sectorDrp
                [items]="unitList"
                (change)="updateUnit($event)"
                [searchable]="false"
                [searchFn]=""
                bindLabel="name"
                formControlName="ingredientUnit"
                placeholder="Unit"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      id="inputValidation"
                      class="form-control accordion-search search-input"
                      (input)="sectorDrp.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  submitForIngredient &&
                  productIngredientForm.get('ingredientDetailFormGroup')?.get('ingredientUnit')
                    ?.invalid
                "
              >
                Unit is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label
                *ngIf="ingredientDetailFormGroup.controls['ingredientCountry'].value"
                class="sub-header-drpdown pb-2"
                >Ingredient country</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #country
                [items]="countryItems"
                [searchable]="false"
                formControlName="ingredientCountry"
                bindLabel="name"
                [searchFn]="commonInputSearchForName"
                placeholder="Country"
                (change)="getCountryId($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="form-control accordion-search search-input search"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="country.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-md-6">
            <label
              *ngIf="ingredientDetailFormGroup.controls['ingredientCountry'].value"
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-autocomplete
              #auto
              [isLoading]="isLoading"
              class="supplierdrpdown"
              (selected)="selectedSupplier($event)"
              (inputChanged)="onChangeSearchSupplier($event)"
              [data]="searchSupplierList"
              (inputCleared)="onClearSearchSupplier($event)"
              [searchKeyword]="keyword"
              historyIdentifier="supplier"
              [itemTemplate]="itemTemplate"
              formControlName="ingredientSupplier"
              placeholder="Select supplier"
            >
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
              <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
            </ng-template>
          </div>
        </div>

        <div class="commonBtnMarginForGrid text-margin">
          <button
            type="button"
            class="actionBTN modelBtn"
            [disabled]="isRowEditable"
            (click)="addIngredient()"
          >
            Add ingredient
          </button>
        </div>
        <div
          *ngrxLet="
            projectFacade.errorMessageForProductIngredient$ as errorMessageForProductIngredient
          "
          class="input-error"
        >
          {{ errorMessageForProductIngredient }}
        </div>
        <div id="divmanufactureofmaterialList " class="grid-div">
          <ng-container *ngrxLet="projectFacade.getIngredientItems$ as getIngredientItems">
            <piqet-angular-portlet
              [columnDefs]="ingredientColumnDef"
              [gridName]="'ingredient column list'"
              [inlineEdit]="true"
              [isInlineGrid]="true"
              [frameworkComponents]="frameworkComponentsMainGrid"
              [gridData]="getIngredientItems"
              [hideSearch]="true"
              [hidePagination]="true"
              [class]="'overflowCheck'"
            >
            </piqet-angular-portlet>
          </ng-container>
        </div>
      </div>

      <hr class="my-4" />
      <div formGroupName="transportationDetailForm">
        <div class="sub-title">
          <h5>Transportation of ingredients to the manufacturer</h5>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div
              class="form-group"
              *ngIf="sharedService.ingredientTransport$ | async as ingredientTransport"
            >
              <label
                *ngIf="
                  productIngredientForm
                    .get('transportationDetailForm')
                    ?.get('ingredientTransportation')?.value
                "
                class="sub-header-drpdown pb-2"
                >Ingredient</label
              >
              <ng-select
                [clearable]="false"
                #option
                [items]="ingredientTransport"
                [searchable]="false"
                [ngClass]="
                  productIngredientForm.controls['transportationDetailForm'].value?.length > 7
                    ? 'multi-select'
                    : ''
                "
                bindLabel="ingredientName"
                formControlName="ingredientTransportation"
                [multiple]="true"
                [searchFn]="commonInputSearchForIngredientName"
                placeholder="Ingredient"
                id="ingredientName"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      style="line-height: 24px"
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input search"
                      id="inputValidation"
                      (input)="option.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.ingredientName }}">
                    {{ item?.ingredientName }}
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.ingredientName }}">
                    {{ item?.ingredientName }}
                  </div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (componentSubmitted || setManualDistanceSubmitted) &&
                  productIngredientForm
                    .get('transportationDetailForm')
                    ?.get('ingredientTransportation')?.errors
                "
              >
                <div
                  *ngIf="
                    productIngredientForm
                      .get('transportationDetailForm')
                      ?.get('ingredientTransportation')?.invalid
                  "
                  class="input-error"
                >
                  Ingredient is required
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <label class="sub-header-drpdown pb-2">{{ ingredientComponent }}</label>
        </div>
        <!-- Transport buttons -->
        <div style="margin-left: -7px" [ngClass]="{ 'disabled-project': isProductEmpty }">
          <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
            <li
              class="nav-item mainLiTag"
              role="presentation"
              (click)="manualLocation(data)"
              *ngFor="let data of wholeData"
            >
              <button
                id="location-tab"
                [ngClass]="
                  selectedBox.id === data.transportaionId &&
                  (selectLocation || selectDistance || selectCustom)
                    ? 'nav-link active'
                    : 'nav-link'
                "
                type="button"
              >
                <div class="image">
                  <img [src]="data.img" [height]="data.heightImg" [width]="data.widthImg" alt="" />
                </div>
                <div>
                  <span
                    [ngClass]="
                      selectedBox.id === data.transportaionId &&
                      (selectLocation || selectDistance || selectCustom)
                        ? 'active'
                        : ''
                    "
                    >{{ data.displayName }}</span
                  >
                </div>
              </button>
            </li>
          </ul>
        </div>

        <!-- Transport button Content -->
        <div
          class="tab-content mt-3"
          *ngrxLet="projectFacade.locationProcessData$ as locationProcessData"
          [ngClass]="{ 'disabled-project': isProductEmpty }"
        >
          <!-- Location -->
          <div class="fade show" *ngIf="selectLocation">
            <div class="row my-3">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
                <div class="d-flex checkBoxAlienMent" *ngIf="locationProcessData?.length > 0">
                  <div>
                    <input
                      type="checkbox"
                      class="chkOverview"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="isCustomTruck"
                      (change)="chnageCustomTruck($event)"
                    />
                  </div>
                  <div>
                    <span class="checkbox-style">Custom truck</span>
                  </div>
                </div>
                <div class="d-flex checkBoxAlienMent">
                  <div>
                    <input type="checkbox" class="chkOverview" (change)="showPorts($event)" />
                  </div>
                  <div>
                    <span class="checkbox-style">Show only ports</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div
                  class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                >
                  <div></div>
                  <div *ngIf="isCustomTruck">
                    <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                      ><span class="redirectLinkText">Add custom truck</span></a
                    >
                    <a
                      class="setLinkIconPosition"
                      target="_blank"
                      replaceUrl="true"
                      routerLink="custom/customTrucks"
                    >
                      <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                    </a>
                    <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                      ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label
                *ngIf="!!isValidPort && locationProcessData.length > 0"
                class="input-error ms-2"
                >{{ isValidPort }}</label
              >
            </div>
            <ng-container *ngrxLet="projectFacade.distanceErrorProject$ as distanceErrorProject">
              <div class="mt-3" *ngIf="distanceErrorProject !== ''">
                <span class="input-error-distance">{{ distanceErrorProject }}</span>
              </div>
            </ng-container>
            <div>
              <ng-container *ngIf="locationProcessData?.length">
                <piqet-angular-portlet
                  [columnDefs]="processColumnDef"
                  [frameworkComponents]="frameworkComponents"
                  [gridData]="locationProcessData"
                  [hideSearch]="true"
                  [hidePagination]="true"
                  [isSetWidth]="true"
                  [gridName]="'product ingredient manual location column list'"
                >
                </piqet-angular-portlet>
              </ng-container>
            </div>
            <ng-template #other_content>
              <div class="row" *ngIf="locationProcessData?.length == 0">
                <div class="col-6">
                  <div class="d-flex justify-content-end align-items-end">
                    <p class="highlights" placeholder="Origin">
                      Select locations with "(Port)" for shipping
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group required">
                    <div class="ng-autocomplete autocomplete">
                      <ng-autocomplete
                        #autoForOrigin
                        [data]="selectedCities"
                        [searchKeyword]="keyword"
                        (inputChanged)="onChangeSearch($event)"
                        historyIdentifier="selectedCities"
                        class="supplierdrpdown"
                        (selected)="selectEvent($event)"
                        [itemTemplate]="itemTemplate"
                        placeholder="Origin"
                        [isLoading]="isLoading"
                        [notFoundTemplate]="notFoundTemplate"
                        formControlName="Origin"
                        (keydown)="onKeyDownEvent($event)"
                        (inputCleared)="onClearSearch($event)"
                        (scrolledToEnd)="onScroll()"
                        [(ngModel)]="keywordAuto"
                      >
                      </ng-autocomplete>
                      <ng-template #itemTemplate let-item>
                        <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                      </ng-template>

                      <ng-template #notFoundTemplate let-notFound>
                        <div [innerHTML]="notFound"></div>
                      </ng-template>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      setOriginsubmitted &&
                      !this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty(
                        'name'
                      )
                    "
                    class="input-error"
                    style="margin-top: 20px"
                  >
                    Select city from list.
                  </div>
                </div>
                <div class="col-sm-1 aligniconQuestion">
                  <span
                    placement="auto"
                    tooltipClass="sku-tooltip"
                    ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                  >
                    <a class="info-icon">
                      <span>
                        <img src="./assets/icons/question-mark-icon.svg" width="14" height="14"
                      /></span>
                    </a>
                  </span>
                </div>
                <div class="col-md-5">
                  <div>
                    <button class="modelBtn setOriginBtn pull-right" (click)="setOrigin()">
                      Set origin
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>
            <div
              *ngIf="locationProcessData?.length > 0 && !checkIsOrginBtn; else other_content"
              class="row mt-3"
            >
              <div class="destinationClass row">
                <div
                  class="col-md-4 d-flex justify-content-end ms-2"
                  [ngClass]="
                    transportationDetailForm.controls['transportModeForLocation'].value
                      ? 'custom-text-position'
                      : ''
                  "
                >
                  <p class="shipping">Select locations with "(Port)" for shipping</p>
                </div>
              </div>
              <div class="col-md-4">
                <label
                  *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                  class="placeholder-sub-header pb-2"
                  >Holder_text</label
                >
                <div>
                  <ng-autocomplete
                    #autoForDestination
                    [data]="selectedCities"
                    [searchKeyword]="keyword"
                    historyIdentifier="selectedCities"
                    [itemTemplate]="itemTemplate"
                    (inputChanged)="onChangeSearch($event)"
                    (selected)="selectEvent($event)"
                    class="supplierdrpdown"
                    [notFoundTemplate]="notFoundTemplate"
                    placeholder="Destination"
                    (inputCleared)="onClearSearch($event)"
                    (keydown)="onKeyDownEvent($event)"
                    formControlName="destination"
                    [isLoading]="isLoading"
                    (scrolledToEnd)="onScroll()"
                    [(ngModel)]="keywordAuto"
                  >
                  </ng-autocomplete>

                  <ng-template #itemTemplate let-item>
                    <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                  </ng-template>

                  <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>
                </div>
                <div
                  *ngIf="
                    setDestinationsubmitted &&
                    !this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty(
                      'name'
                    )
                  "
                  class="input-error destinatioErrorMessage"
                >
                  Select city from list.
                </div>
              </div>
              <div class="col-md-4" *ngIf="!isCustomTruck">
                <div class="required" aria-required="true">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                    class="sub-header-drpdown pb-2"
                    >Transport mode</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="transportModeItems"
                    [searchable]="false"
                    formControlName="transportModeForLocation"
                    (change)="changeTransportMode($event)"
                    bindLabel="name"
                    [searchFn]="commonInputSearchForName"
                    placeholder="Select transport mode"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control search-input search"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="select.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  *ngIf="
                    setDestinationsubmitted &&
                    !transportationDetailForm.controls['transportModeForLocation'].value
                  "
                  class="input-error"
                >
                  Please select transport mode
                </div>
              </div>
              <div class="col-md-4" *ngIf="isCustomTruck">
                <div class="form-group required" aria-required="true">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                    class="sub-header-drpdown pb-2"
                    >Transport mode</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="customTruckItems"
                    [searchable]="false"
                    formControlName="transportModeForLocation"
                    (change)="changeTransportMode($event)"
                    bindLabel="name"
                    [searchFn]="commonInputSearchForName"
                    placeholder="Select transport mode"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control search-input search"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  *ngIf="
                    setDestinationsubmitted &&
                    !transportationDetailForm.controls['transportModeForLocation'].value
                  "
                  class="input-error"
                >
                  Please select transport mode
                </div>
              </div>
              <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                <div class="form-group required" aria-required="true">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div class="services-form">
                    <input
                      (keydown)="noSpecialKeys($event)"
                      placeholder="Distance"
                      formControlName="distanceManulaLocation"
                    />
                    <label>Distance </label>
                  </div>
                  <div *ngIf="setDestinationsubmitted">
                    <div
                      *ngIf="transportationDetailForm.controls['distanceManulaLocation'].value == 0"
                      class="input-error"
                    >
                      The number of licenses must be greater than 0
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label
                  *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                  class="placeholder-sub-header pb-2"
                  >Holder_text</label
                >
                <div>
                  <button
                    class="modelBtn setOriginBtn"
                    *ngIf="!isCheckUpdateDestination"
                    (click)="setDestination()"
                  >
                    Add transport leg
                  </button>
                  <button
                    class="modelBtn setOriginBtn"
                    *ngIf="isCheckUpdateDestination"
                    (click)="setDestination()"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Distance -->
          <div class="fade show" *ngIf="selectDistance">
            <div class="row my-3">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="d-flex checkBoxAlienMent">
                  <div>
                    <input
                      type="checkbox"
                      class="chkOverview"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="isCustomTruck"
                      (change)="chnageCustomTruck($event)"
                    />
                  </div>
                  <div>
                    <span class="checkbox-style">Custom truck</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div
                  class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                >
                  <div></div>
                  <div>
                    <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                      ><span class="redirectLinkText">Add custom truck</span></a
                    >
                    <a
                      class="setLinkIconPosition"
                      target="_blank"
                      replaceUrl="true"
                      routerLink="custom/customTrucks"
                    >
                      <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                    </a>
                    <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                      ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngrxLet="projectFacade.distanceProcessData$ as distanceProcessData">
              <ng-container *ngIf="distanceProcessData?.length > 0">
                <piqet-angular-portlet
                  [columnDefs]="distanceProcessColumnDef"
                  [isSetWidth]="true"
                  [frameworkComponents]="frameworkComponents"
                  [gridData]="distanceProcessData"
                  [hideSearch]="true"
                  [hidePagination]="true"
                  [gridName]="'product ingredient manual distance column list'"
                >
                </piqet-angular-portlet>
              </ng-container>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="form-group required" aria-required="true">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                    class="sub-header-drpdown pb-2"
                    >Transport mode</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="transportModeItems"
                    [searchable]="false"
                    *ngIf="!isCustomTruck"
                    formControlName="transportModeForDistance"
                    (change)="changeTransportMode($event)"
                    bindLabel="name"
                    [searchFn]="commonInputSearchForName"
                    placeholder="Transport mode"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control search-input search"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="customTruckItems"
                    [searchable]="false"
                    *ngIf="isCustomTruck"
                    formControlName="transportModeForDistance"
                    (change)="changeTransportMode($event)"
                    bindLabel="name"
                    [searchFn]="commonInputSearchForName"
                    placeholder="Transport mode"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control search-input search"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>

                  <div
                    *ngIf="
                      setManualDistanceSubmitted &&
                      !transportationDetailForm.controls['transportModeForDistance'].value
                    "
                    class="input-error"
                  >
                    Please select transport mode
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="form-group required" aria-required="true">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div class="services-form">
                    <input
                      type="number"
                      maxlength="100"
                      placeholder="Component name"
                      formControlName="distance"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    />
                    <label>Distance</label>
                  </div>
                  <div *ngIf="setManualDistanceSubmitted">
                    <div
                      *ngIf="transportationDetailForm.controls['distance'].value === 0"
                      class="input-error"
                    >
                      The number of licenses must be greater than 0
                    </div>
                  </div>
                  <div
                    *ngIf="
                      setManualDistanceSubmitted &&
                      !transportationDetailForm.controls['distance'].value &&
                      transportationDetailForm.controls['distance'].value !== 0
                    "
                    class="input-error"
                  >
                    Please select distance
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="add-button">
                  <button
                    class="actionBTN modelBtn purple-button"
                    *ngIf="!isCheckEditManudalDist"
                    (click)="addTransportDistance()"
                  >
                    Add transport leg
                  </button>
                  <button
                    class="actionBTN modelBtn purple-button"
                    *ngIf="isCheckEditManudalDist"
                    (click)="addTransportDistance()"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Custom -->
          <div class="fade show" *ngIf="selectCustom">
            <div class="row mt-3">
              <div>
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <div></div>
                    <div>
                      <a class="add-link" target="_blank" routerLink="custom/customTransport"
                        ><span class="redirectLinkText">Add custom transport scenario</span></a
                      >
                      <a
                        class="setLinkIconPosition"
                        target="_blank"
                        replaceUrl="true"
                        routerLink="custom/customTransport"
                      >
                        <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                      </a>
                      <span class="setLinkIconPosition" (click)="getCustomTransport()"
                        ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="form-group required">
                  <label
                    *ngIf="transportationDetailForm.controls['customScenarioItem'].value"
                    class="sub-header-drpdown pb-2"
                    >Selected custom freight scenario</label
                  >
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #select
                    [items]="customtransportScenarioItems"
                    [searchable]="false"
                    formControlName="customScenarioItem"
                    bindLabel="name"
                    (change)="changeCustomTransportItem($event)"
                    (clear)="resetTransport()"
                    [searchFn]="commonInputSearchForName"
                    placeholder="Select custom freight mode"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          class="search"
                          type="text"
                          class="form-control search-input search"
                          id="inputValidation"
                          (input)="select.filter($any($event.target).value)"
                          placeholder="Search..."
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="add-button">
                  <button class="actionBTN modelBtn purple-button" (click)="addCustomFreight()">
                    Add transport leg
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div *ngrxLet="projectFacade.freightProcessData$ as freightProcessData">
            <div *ngIf="freightProcessData?.length > 0 && !selectLocation && !selectDistance">
              <piqet-angular-portlet
                [columnDefs]="customTransportDef"
                [gridData]="freightProcessData"
                [hideSearch]="true"
                [isSetWidth]="true"
                [hidePagination]="true"
                [gridName]="'product ingredien  custom transport'"
              >
              </piqet-angular-portlet>
            </div>
          </div>
        </div>

        <div
          [ngClass]="{ 'disabled-project': isProductEmpty }"
          class="commonBtnMarginForGrid text-margin"
          *ngrxLet="{
            locationProcessData: (projectFacade.locationProcessData$ | async),
            distanceProcessData: (projectFacade.distanceProcessData$ | async),
            freightProcessData: (projectFacade.freightProcessData$ | async)
          } as addTransportData"
        >
          <button
            type="button"
            class="actionBTN modelBtn purpleBtnHoverEffect"
            (click)="
              addIngredientTransport(
                addTransportData.locationProcessData,
                addTransportData.distanceProcessData,
                addTransportData.freightProcessData
              )
            "
          >
            Add ingredient transport
          </button>
        </div>
        <div id="divmanufactureofmaterialList" class="grid-div">
          <ng-container
            *ngrxLet="projectFacade.getIngredientTransportItems$ as getIngredientTransportItems"
          >
            <piqet-angular-portlet
              [columnDefs]="ingredientTransportColumnDef"
              [hidePagination]="true"
              [hideSearch]="true"
              [frameworkComponents]="frameworkComponentsForIngredientTransport"
              [gridData]="getIngredientTransportItems"
              [class]="'overflowCheck'"
              [gridName]="'product ingredient manufacture custom transport column list'"
            >
            </piqet-angular-portlet>
          </ng-container>
        </div>
      </div>

      <hr class="my-4" />
      <div formGroupName="manufacturingForm">
        <div>
          <h5>Manufacturing process</h5>
        </div>

        <div class="row">
          <div [ngClass]="!isCustomProcess ? 'col-md-6' : 'col-md-12'">
            <div class="form-group required">
              <label class="sub-header-drpdown">Manufacturing process</label>
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #process
                [items]="manufactureItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="processName"
                [searchFn]="commonInputSearchForName"
                placeholder="Manufacturing process *"
                groupBy="childItems"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="process.filter($any($event.target).value)"
                      class="form-control search-input search"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                    {{ item?.name }}
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                    {{ item?.name }}
                  </div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  submitForManufacture &&
                  productIngredientForm.get('manufacturingForm')?.get('processName')?.errors
                "
              >
                <div
                  *ngIf="
                    productIngredientForm.get('manufacturingForm')?.get('processName')?.invalid
                  "
                  class="input-error"
                >
                  Please select energy process
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="!isCustomProcess">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                label="Amount"
                name="amount"
                placeholder="Amount"
                formControlName="amount"
                [control]="manufacturingForm?.get('amount')"
                [submitted]="submitForManufacture"
                [maxLength]="100"
                inputType="number"
                [required]="true"
                [preventNegative]="true"
                (customBlur)="getCostPerPackage()"
                [errorMessages]="{
                  nonNegative: 'Please enter a positive value.'
                }"
              ></piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isCostTrunOff && !isCustomProcess">
          <div class="col-md-6">
            <div class="form-group" aria-required="true">
              <piqet-angular-common-input
                label="Cost per unit"
                name="costPerUnit"
                placeholder="Cost per unit"
                formControlName="costPerUnit"
                [control]="manufacturingForm?.get('costPerUnit')"
                [maxLength]="100"
                inputType="number"
                [preventNegative]="true"
                (customBlur)="getCostPerPackage()"
              ></piqet-angular-common-input>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group" aria-required="true">
              <piqet-angular-common-input
                label="Cost per package (USD)"
                name="costPerPackage"
                placeholder="Cost per package (USD)"
                formControlName="costPerPackage"
                [control]="manufacturingForm?.get('costPerPackage')"
                [maxLength]="100"
                inputType="number"
                [disabled]="true"
              ></piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="commonBtnMarginForGrid text-margin">
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="addProcess()">
            {{ manufactureEditMode ? 'Edit process' : 'Add process' }}
          </button>
        </div>

        <ng-container *ngrxLet="projectFacade.getManufacturProcess$ as getManufacturProcess">
          <ng-container>
            <div
              id="divmanufactureofmaterialList"
              class="grid-div"
              *ngIf="getManufacturProcess.length > 0"
            >
              <piqet-angular-portlet
                [class]="'overflowCheck'"
                [columnDefs]="!isCostTrunOff ? manufactureColumnDef : manufactureColumnDefForCost"
                [frameworkComponents]="frameworkComponents"
                [gridData]="getManufacturProcess"
                [gridName]="'product ingredient getManufacturProcess list'"
                [hidePagination]="true"
                [hideSearch]="true"
              >
              </piqet-angular-portlet>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </form>
  </div>

  <div class="setButtonAndError text-margin">
    <div
      class="modal-footer"
      *ngrxLet="{
        getManufacturProcess: (projectFacade.getManufacturProcess$ | async),
        getIngredientItems: (projectFacade.getIngredientItems$ | async),
        replicaLocation: (projectFacade.replicaLocation$ | async),
        replicaDistance: (projectFacade.replicaDistance$ | async),
        getIngredientTransportItems: (projectFacade.getIngredientTransportItems$ | async)
      } as paroductIngredient"
    >
      <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
      <button
        type="button"
        class="modelBtn purpleBtnHoverEffect"
        *ngIf="showEdit"
        [disabled]="isRowEditable"
        (click)="
          saveData(
            paroductIngredient.getManufacturProcess,
            paroductIngredient.getIngredientItems,
            paroductIngredient.replicaLocation,
            paroductIngredient.replicaDistance,
            paroductIngredient.getIngredientTransportItems
          )
        "
      >
        Save
      </button>
    </div>
  </div>
</div>
